import { render, staticRenderFns } from "./VisitCalendarView.vue?vue&type=template&id=2074925f"
import script from "./VisitCalendarView.vue?vue&type=script&lang=js"
export * from "./VisitCalendarView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports